import { useState, useEffect } from 'react';

/**
 * Hook personalizado para detectar media queries
 * @param {string} query - La media query a evaluar (ej: '(max-width: 768px)')
 * @returns {boolean} - true si la media query coincide, false en caso contrario
 */
const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    // Verificar si window está disponible (SSR safety)
    if (typeof window === 'undefined') {
      return;
    }

    const mediaQuery = window.matchMedia(query);
    
    // Establecer el valor inicial
    setMatches(mediaQuery.matches);

    // Función para manejar cambios
    const handleChange = (event) => {
      setMatches(event.matches);
    };

    // Agregar listener
    mediaQuery.addEventListener('change', handleChange);

    // Cleanup
    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, [query]);

  return matches;
};

export default useMediaQuery;
